module.exports = __webpack_public_path__ + "static/media/mercedes-banner.77028aaa.png";